import script from "./ReceiveNFTTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceiveNFTTable.vue?vue&type=script&setup=true&lang=ts"

import "./ReceiveNFTTable.vue?vue&type=style&index=0&id=5545d8c5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5545d8c5"]])

export default __exports__